import { ComboPreventionPickError } from '../result/combo-prevention-pick-error';
import { IPickPreCheckError, PreCheckErrorMessages, PreCheckErrorMixin } from './pre-check-error';

export class ComboPreventionPreCheckError extends PreCheckErrorMixin(ComboPreventionPickError) implements IPickPreCheckError {
    constructor(
        pickId: string,
        readonly messageKey: keyof PreCheckErrorMessages,
    ) {
        super(pickId, void 0);
    }
}
